import { render, staticRenderFns } from "./ScriptManagement.vue?vue&type=template&id=32ad0ff9&"
import script from "./ScriptManagement.vue?vue&type=script&lang=js&"
export * from "./ScriptManagement.vue?vue&type=script&lang=js&"
import style0 from "./ScriptManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports